import React from 'react';
import { useTheme } from '../context/ThemeContext';

const Footer = () => {
  const { darkMode } = useTheme();
  const currentYear = new Date().getFullYear();

  return (
    <footer className={`border-t py-6 mt-auto transition-colors duration-200 ${darkMode ? 'bg-slate-900 border-slate-800 text-gray-400' : 'bg-stone-100 border-stone-200 text-stone-400'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center text-sm">
          <p>
            &copy; {currentYear} JX Media. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
